<template>
	<DashboardModal
		ref="modal"
		width="500px"
		prompt
		:class="$style['confirmation-modal']"
		@modal-toggle="close"
	>
		<DashboardFormTitle>
			{{ $t('rules.title.'+rules.name) }}
		</DashboardFormTitle>
		<div :class="$style['confirmation-modal__content']">
			<p>{{ rules.description }}</p>
		</div>
		<div :class="$style['confirmation-modal__buttons']">
			<BaseButton
				:full="true"
				danger
				:white="true"
				:loading="isLoading.decline"
				:class="$style['confirmation-modal__button']"
				@click="submit('decline')"
			>
				{{ $t('common.actions.decline') }}
			</BaseButton>
			<BaseButton
				v-testid="'confirm-additional-services'"
				:full="true"
				primary
				:loading="isLoading.accept"
				:class="$style['confirmation-modal__button']"
				@click="submit('accept')"
			>
				{{ $t('common.actions.accept') }}
			</BaseButton>
		</div>
	</DashboardModal>
</template>

<script>
import DashboardModal from '@/components/Layout/Dashboard/Modal'
import DashboardFormTitle from '@/components/Layout/Dashboard/Form/FormTitle'
import MakeDepartmentRuleAction from './MakeDepartmentRuleAction.gql'

export default {
	name: 'AcceptRulesModal',
	components: {
		DashboardModal,
		DashboardFormTitle
	},
	props: {
		rules: {
			type: Object,
			required: true
		}
	},
	data: () => ({
		isLoading: {
			accept: false,
			decline: false
		}
	}),
	methods: {
		async makeAction (status) {
			await this.$apollo.mutate({
				mutation: MakeDepartmentRuleAction,
				variables: {
					payload: {
						departmentId: this.$auth().selectedDepartmentId,
						ruleId: this.rules.id,
						accepted: status === 'accept' ? true : false
					}
				}
			})
		},
		async submit (status) {
			this.isLoading[status] = true
			try {
				await this.makeAction(status)
			} catch (_e) {
				this.isLoading[status] = false
				this.close()
			}
			this.isLoading[status] = false
			this.close()
		},

		async close () {
			this.$emit('closed')
		}
	}
}
</script>
<style lang="scss" module>
.confirmation-modal {
		&__content {
			padding: 10px 0;
		}

		&__buttons {
			display: flex;
			margin: 0 (-20px);
			margin-top: 10px;
		}

		&__button {
			margin: 0 20px;
			// margin-bottom: 20px;
		}
	}
</style>
